export const ACCESS_TOKEN_KEY = 'access_token_key';


// WEBPACK FOOTER //
// ./src/services/constant.js